/* tslint:disable:indent */
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {StringFunctions} from '../functions/string-functions';
import {API_ENDPOINTS} from '../api/api-endpoints';
import {WhmcsClient, WhmcsClientDetails} from '../models/whmcs-client.model';
import {WhmcsStats} from '../models/whmcs-stats.model';
import {AudioStream} from '../models/audio-stream.model';

@Injectable({providedIn: 'root'})
export class Html5playersStatsService {
	getStreams(status: number): Observable<AudioStream[]> {
		return this.http.post(
			API_ENDPOINTS.HTML5PLAYERS.GET_STREAM_STATS,
			{
				status: status
			}
			)
			.pipe(
				map((response: any) => {
					if (!response.error) {
						return this.toAudioStreamArray(response.message);
					} else {
						return [];
					}
				})
			);
	}

	updateStreamStatus(streamId: number, newStatus: number){
		return this.http.post(
			API_ENDPOINTS.HTML5PLAYERS.UPDATE_STREAM_STATUS,
			{
				streamId: streamId,
				newStatus: newStatus
			}
		);
	}

	private toAudioStreamArray(data): AudioStream[] {
		const streams: AudioStream[] = [];
		for (const item of data) {
			streams.push(
				new AudioStream(
					parseInt(item.SID, 10),
					StringFunctions.emptyToNull(item.Webpage),
					parseInt(item.Player, 10),
					StringFunctions.emptyToNull(item.StreamUrl),
					parseInt(item.Status, 10)
				)
			);
		}
		return streams;
	}

	constructor(private http: HttpClient) { }
}
